import { render, staticRenderFns } from "./StacFields.vue?vue&type=template&id=754f36d2"
import script from "./StacFields.vue?vue&type=script&lang=js"
export * from "./StacFields.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./StacFields.vue?vue&type=style&index=0&id=754f36d2&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports